// src/pages/couriers/components/RuleConfigPreview.jsx
import React from 'react';
import { Eye, EyeOff, ChevronDown, ChevronUp, Building2, MapPin, Package } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './RuleConfigPreview.module.css';

const RuleConfigPreview = ({ rules, isExpanded, onToggleExpansion }) => {
  const { t } = useLocalization();

  const ruleTypes = [
    { key: 'shopRules', label: t('couriers.shop'), icon: Building2, color: '#8b5cf6' },
    { key: 'cityRules', label: t('couriers.city'), icon: MapPin, color: '#3b82f6' },
    { key: 'shippingZoneRules', label: t('couriers.zone'), icon: Package, color: '#10b981' },
    { key: 'districtRules', label: t('couriers.district'), icon: MapPin, color: '#f59e0b' },
    { key: 'provinceRules', label: t('couriers.province'), icon: MapPin, color: '#ef4444' }
  ];

  const hasRules = ruleTypes.some(rt => rules[rt.key]?.length > 0);

  return (
    <>
      <div className={styles.ruleConfigHeader}>
        <span className={styles.configLabel}>{t('couriers.configuration')}:</span>
        <button onClick={onToggleExpansion} className={styles.expandButton}>
          {isExpanded ? (
            <>
              <EyeOff size={14} />
              {t('couriers.hideDetails')}
            </>
          ) : (
            <>
              <Eye size={14} />
              {t('couriers.showDetails')}
            </>
          )}
          {isExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </button>
      </div>
      {!isExpanded && (
        hasRules ? (
          <div className={styles.rulePreview}>
            {ruleTypes.map(({ key, label, icon: Icon, color }) => {
              const ruleCount = rules[key]?.length || 0;
              if (ruleCount === 0) return null;
              const includeCount = rules[key].filter(r => r.type === 'include').length;
              const excludeCount = rules[key].filter(r => r.type === 'exclude').length;
              return (
                <div key={key} className={styles.rulePreviewItem} style={{ borderLeftColor: color }}>
                  <Icon size={14} style={{ color }} />
                  <span className={styles.ruleLabel}>{label}:</span>
                  {includeCount > 0 && <span className={styles.includeCount}>+{includeCount}</span>}
                  {excludeCount > 0 && <span className={styles.excludeCount}>-{excludeCount}</span>}
                </div>
              );
            })}
          </div>
        ) : (
          <span className={styles.noRules}>{t('couriers.noRulesConfigured')}</span>
        )
      )}
    </>
  );
};

export default RuleConfigPreview;